module.exports = __webpack_public_path__ + "img/13.2678207d.png";